// extracted by mini-css-extract-plugin
export default {"noReservations":"DepartureGroup_noReservations__-7703"};